import React from "react";
import styled from "styled-components";
import {
  experienceData,
  projectData,
  educationData,
  certificateData,
  aboutData,
} from "../../helpers/constant";
import { FaTrash } from "react-icons/fa";
import "./styles.css";

const StaticTemplate = (props) => (
  <Body className="body" font={props.state.fontName} data-gr-c-s-loaded="true">
    <Header color={props.state.color}>
      <span className="headerTitle">
        <span
          className="headerTitle"
          contentEditable="true"
          suppressContentEditableWarning="true"
          onBlur={(e) =>
            props.setNormalValueToState("name", e.currentTarget.textContent)
          }
        >
          {props.state.name}
        </span>
        <span
          className="surname"
          contentEditable="true"
          suppressContentEditableWarning="true"
          onBlur={(e) =>
            props.setNormalValueToState("surname", e.currentTarget.textContent)
          }
        >
          {props.state.surname}
        </span>
      </span>
    </Header>

    <section className="container">
      <div className="sideMenu">
        <div className="entityContainer">
          <h4 className="entityTitle">Position</h4>
          <span
            className="entityValue"
            contentEditable="true"
            suppressContentEditableWarning="true"
            onBlur={(e) =>
              props.setNormalValueToState(
                "position",
                e.currentTarget.textContent
              )
            }
          >
            {props.state.position}
          </span>
        </div>

        <div className="entityContainer">
          <h4 className="entityTitle">Skills</h4>
          <div className="skillContainer">
            {props.state.skills.map((item, index) => (
              <Skill
                color={props.state.color}
                className="skillItem"
                key={`skillItem_${index}`}
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayValueToState(
                    "skills",
                    index,
                    e.currentTarget.textContent
                  )
                }
              >
                {item}
              </Skill>
            ))}
            <button
              className="btn-circle-plus"
              onClick={() => props.addNewArrayValue("skills")}
            >
              +
            </button>
          </div>
        </div>

        <div className="entityContainer">
          <h4 className="entityTitle">Interests</h4>
          <div className="itemContainer">
            {props.state.interests.map((item, index) => (
              <div
                className="item arrayItem"
                key={`interests_${index}`}
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayValueToState(
                    "interests",
                    index,
                    e.currentTarget.textContent
                  )
                }
              >
                {item}
              </div>
            ))}
            <button
              className="btn-circle-plus"
              onClick={() => props.addNewArrayValue("interests")}
            >
              +
            </button>
          </div>
        </div>

        <div className="entityContainer">
          <h4 className="entityTitle">Programming Languages</h4>
          <div className="itemContainer">
            {props.state.proLanguages.map((item, index) => (
              <div
                className="item arrayItem"
                key={`proLanguages_${index}`}
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayValueToState(
                    "proLanguages",
                    index,
                    e.currentTarget.textContent
                  )
                }
              >
                {item}
              </div>
            ))}
            <button
              className="btn-circle-plus"
              onClick={() => props.addNewArrayValue("proLanguages")}
            >
              +
            </button>
          </div>
        </div>

        <div className="entityContainer">
          <h4 className="entityTitle">Languages</h4>
          <div className="itemContainer">
            {props.state.spolanguages.map((item, index) => (
              <div
                className="item arrayItem"
                key={`spolanguages_${index}`}
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayValueToState(
                    "spolanguages",
                    index,
                    e.currentTarget.textContent
                  )
                }
              >
                {item}
              </div>
            ))}
            <button
              className="btn-circle-plus"
              onClick={() => props.addNewArrayValue("spolanguages")}
            >
              +
            </button>
          </div>
        </div>

        <div className="entityContainer">
          <h4 className="entityTitle">Other</h4>
          <div className="itemContainer">
            {props.state.otherSkills.map((item, index) => (
              <div
                className="item arrayItem"
                key={`otherSkills_${index}`}
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayValueToState(
                    "otherSkills",
                    index,
                    e.currentTarget.textContent
                  )
                }
              >
                {item}
              </div>
            ))}
            <button
              className="btn-circle-plus"
              onClick={() => props.addNewArrayValue("otherSkills")}
            >
              +
            </button>
          </div>
        </div>

        <div className="entityContainer">
          <h4 className="entityTitle">Address</h4>
          <span className="entityValue">
            <span
              className="addressItem"
              contentEditable="true"
              suppressContentEditableWarning="true"
              onBlur={(e) =>
                props.setObjectValueToState(
                  "address",
                  "area",
                  e.currentTarget.textContent
                )
              }
            >
              {props.state.address.area}
            </span>
            ,<br />
            <span
              contentEditable="true"
              className="addressItem"
              suppressContentEditableWarning="true"
              onBlur={(e) =>
                props.setObjectValueToState(
                  "address",
                  "city",
                  e.currentTarget.textContent
                )
              }
            >
              {props.state.address.city}
            </span>
            <span
              contentEditable="true"
              suppressContentEditableWarning="true"
              className="addressItem"
              onBlur={(e) =>
                props.setObjectValueToState(
                  "address",
                  "pin",
                  e.currentTarget.textContent
                )
              }
            >
              {props.state.address.pin}
            </span>
            ,<br />
            <span
              contentEditable="true"
              className="addressItem"
              suppressContentEditableWarning="true"
              onBlur={(e) =>
                props.setObjectValueToState(
                  "address",
                  "country",
                  e.currentTarget.textContent
                )
              }
            >
              {props.state.address.country}
            </span>
          </span>
        </div>
      </div>

      <div className="main">
        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Obj</span>ective
          </h1>
          <FaTrash
                    className="marRight-10"
                    onClick={() =>
                      props.deleteSingleItem("objective")
                    }
                  />
          <div
                className="item arrayItem" 
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setNormalValueToState(
                    "objective",
                    e.currentTarget.textContent
                  )}
                >{props.state.objective}</div>
        </div>
        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Ex</span>perience
          </h1>
          {props.state.experience.map((item, index) => (
            <div className="menuContainer" key={`exp_container_${index}`}>
              <div className="dateContainer">
                <span className="fs-13">
                  <FaTrash
                    className="marRight-10"
                    onClick={() =>
                      props.deleteFromArrayOfObject("experience", index)
                    }
                  />
                  <span
                    contentEditable="true"
                    suppressContentEditableWarning="true"
                    onBlur={(e) =>
                      props.setArrayOfObjectToState(
                        "experience",
                        index,
                        "from",
                        e.currentTarget.textContent
                      )
                    }
                    className="fs-13"
                  >
                    {item.from}
                  </span>
                  <span> - </span>
                  <span
                    className="fs-13"
                    contentEditable="true"
                    suppressContentEditableWarning="true"
                    onBlur={(e) =>
                      props.setArrayOfObjectToState(
                        "experience",
                        index,
                        "to",
                        e.currentTarget.textContent
                      )
                    }
                  >
                    {item.to}
                  </span>
                </span>
              </div>

              <div className="expDetailsContainer">
                <div className="expHeader">
                  <div className="comNamePos">
                    <span
                      className="itemHeader"
                      contentEditable="true"
                      suppressContentEditableWarning="true"
                      onBlur={(e) =>
                        props.setArrayOfObjectToState(
                          "experience",
                          index,
                          "company",
                          e.currentTarget.textContent
                        )
                      }
                    >
                      {item.company}
                    </span>
                    <span
                      contentEditable="true"
                      suppressContentEditableWarning="true"
                      onBlur={(e) =>
                        props.setArrayOfObjectToState(
                          "experience",
                          index,
                          "position",
                          e.currentTarget.textContent
                        )
                      }
                      className="itemSubHeader"
                    >
                      {item.position}
                    </span>
                  </div>
                  <div className="place">
                    <span
                      className="fs-13"
                      contentEditable="true"
                      suppressContentEditableWarning="true"
                      onBlur={(e) =>
                        props.setArrayOfObjectToState(
                          "experience",
                          index,
                          "place",
                          e.currentTarget.textContent
                        )
                      }
                    >
                      {item.place}
                    </span>
                  </div>
                </div>
                <div className="marTop-10">
                  <span
                    className="expDetails"
                    contentEditable="true"
                    suppressContentEditableWarning="true"
                    onBlur={(e) =>
                      props.setArrayOfObjectToState(
                        "experience",
                        index,
                        "jobDescription",
                        e.currentTarget.textContent
                      )
                    }
                  >
                    {item.jobDescription}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <button
            className="btn-circle-plus"
            onClick={() =>
              props.addNewArrayOfObject(
                "experience",
                JSON.parse(JSON.stringify(experienceData))
              )
            }
          >
            +
          </button>
        </div>

        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Edu</span>cation
          </h1>

          {props.state.education.map((item, index) => (
            <div
              className="flx-col marTop-10 marLeft-10"
              key={`edu_container_${index}`}
            >
              <div>
                <span
                  contentEditable="true"
                  suppressContentEditableWarning="true"
                  onBlur={(e) =>
                    props.setArrayOfObjectToState(
                      "education",
                      index,
                      "course",
                      e.currentTarget.textContent
                    )
                  }
                  className="itemHeader"
                >
                  {item.course}
                </span>
                <FaTrash
                  className="marLeft-10"
                  onClick={() =>
                    props.deleteFromArrayOfObject("education", index)
                  }
                />
              </div>
              <span
                className="itemSubHeader"
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayOfObjectToState(
                    "education",
                    index,
                    "time",
                    e.currentTarget.textContent
                  )
                }
              >
                {item.time}
              </span>
              <div className="marTop-10">
                <span
                  className="expDetails"
                  contentEditable="true"
                  suppressContentEditableWarning="true"
                  onBlur={(e) =>
                    props.setArrayOfObjectToState(
                      "education",
                      index,
                      "desc",
                      e.currentTarget.textContent
                    )
                  }
                >
                  {item.desc}
                </span>
              </div>
            </div>
          ))}
          <button
            className="btn-circle-plus"
            onClick={() =>
              props.addNewArrayOfObject(
                "education",
                JSON.parse(JSON.stringify(educationData))
              )
            }
          >
            +
          </button>
        </div>

        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Proj</span>ects
          </h1>
          {props.state.project.map((item, index) => (
            <div
              className="flx-col marTop-10 marLeft-10"
              key={`proj_container_${index}`}
            >
              <div>
                <span
                  contentEditable="true"
                  suppressContentEditableWarning="true"
                  onBlur={(e) =>
                    props.setArrayOfObjectToState(
                      "project",
                      index,
                      "name",
                      e.currentTarget.textContent
                    )
                  }
                  className="itemHeader"
                >
                  {item.name}
                </span>
                <FaTrash
                  className="marLeft-10"
                  onClick={() =>
                    props.deleteFromArrayOfObject("project", index)
                  }
                />
              </div>
              <div className="marTop-10">
                <span
                  contentEditable="true"
                  suppressContentEditableWarning="true"
                  onBlur={(e) =>
                    props.setArrayOfObjectToState(
                      "project",
                      index,
                      "desc",
                      e.currentTarget.textContent
                    )
                  }
                  className="expDetails"
                >
                  {item.desc}
                </span>
              </div>
            </div>
          ))}
          <button
            className="btn-circle-plus"
            onClick={() =>
              props.addNewArrayOfObject(
                "project",
                JSON.parse(JSON.stringify(projectData))
              )
            }
          >
            +
          </button>
        </div>

        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Achi</span>evements
          </h1>
          {props.state.achievement.map((item, index) => (
            <div className="flx-col" key={`achie_container_${index}`}>
              <span
                key={`achievement_Item_${index}`}
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayValueToState(
                    "achievement",
                    index,
                    e.currentTarget.textContent
                  )
                }
                className="marLeft-10 arrayItem"
              >
                {item}
              </span>
            </div>
          ))}
          <button
            className="btn-circle-plus"
            onClick={() => props.addNewArrayValue("achievement")}
          >
            +
          </button>
        </div>

        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Cert</span>ificates
          </h1>
          {props.state.certificate.map((item, index) => (
            <div
              className="flx-col marLeft-10 marTop-10"
              key={`cert_container_${index}`}
            >
              <div>
                <span
                  contentEditable="true"
                  suppressContentEditableWarning="true"
                  onBlur={(e) =>
                    props.setArrayOfObjectToState(
                      "certificate",
                      index,
                      "name",
                      e.currentTarget.textContent
                    )
                  }
                  className="itemHeader"
                >
                  {item.name}
                </span>
                <FaTrash
                  className="marLeft-10"
                  onClick={() =>
                    props.deleteFromArrayOfObject("certificate", index)
                  }
                />
              </div>
              <span
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayOfObjectToState(
                    "certificate",
                    index,
                    "provider",
                    e.currentTarget.textContent
                  )
                }
                className="itemSubHeader"
              >
                {item.provider}
              </span>
            </div>
          ))}
          <button
            className="btn-circle-plus"
            onClick={() =>
              props.addNewArrayOfObject(
                "certificate",
                JSON.parse(JSON.stringify(certificateData))
              )
            }
          >
            +
          </button>
        </div>

        <div className="marTop-10 brerak-Avoid">
          <h1 className="menuHeader">
            <span className="colorChange">Ab</span>out Me
          </h1>

          {props.state.about.map((item, index) => (
            <div
              className="flx-col marLeft-10 marTop-10"
              key={`about_container_${index}`}
            >
              <div>
                <span
                  contentEditable="true"
                  suppressContentEditableWarning="true"
                  onBlur={(e) =>
                    props.setArrayOfObjectToState(
                      "about",
                      index,
                      "platform",
                      e.currentTarget.textContent
                    )
                  }
                  className="itemHeader"
                >
                  {item.platform}
                </span>
                <FaTrash
                  className="marLeft-10"
                  onClick={() => props.deleteFromArrayOfObject("about", index)}
                />
              </div>
              <a
                href="#/"
                contentEditable="true"
                suppressContentEditableWarning="true"
                onBlur={(e) =>
                  props.setArrayOfObjectToState(
                    "about",
                    index,
                    "link",
                    e.currentTarget.textContent
                  )
                }
                className="itemSubHeader"
              >
                {item.link}
              </a>
            </div>
          ))}
          <button
            className="btn-circle-plus"
            onClick={() =>
              props.addNewArrayOfObject(
                "about",
                JSON.parse(JSON.stringify(aboutData))
              )
            }
          >
            +
          </button>
        </div>
      </div>
    </section>
  </Body>
);

const Header = styled.header`
  background-color: ${(props) => props.color};
`;
const Skill = styled.div`
  background-color: ${(props) => props.color};
`;
const Body = styled.div`
  margin: 0;
  padding-bottom: 40px;
  box-shadow: 0px 1px 3px 0px rgba(163, 143, 163, 1);
  background-color: white;
`;

export default StaticTemplate;
